import { render, staticRenderFns } from "./brandMatrix.vue?vue&type=template&id=922ed0c2&scoped=true"
import script from "./brandMatrix.vue?vue&type=script&lang=js"
export * from "./brandMatrix.vue?vue&type=script&lang=js"
import style0 from "./brandMatrix.vue?vue&type=style&index=0&id=922ed0c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "922ed0c2",
  null
  
)

export default component.exports